export function buildClientLogoUrl(path: string | null | undefined): string | null {
  const p = path?.trim();
  if (!p) return null;
  if (/^https?:\/\//i.test(p)) return p;
  const base =
    process.env.REACT_APP_CLOUD_FRONT_URL?.trim().replace(/\/+$/, "") ||
    process.env.REACT_APP_ASSET_BASE_URL?.trim().replace(/\/+$/, "") ||
    "";
  if (!base) return null;
  return `${base}/${p.replace(/^\/+/, "")}`;
}
